/*Auto-generated at pre-build.js*/
export class BuildDetails {
  public static readonly isoDate = "2000-01-01T00:00:00.000Z";
}
